<mat-dialog-content
  ><app-dynamic-table
    *ngIf="data"
    [tableProps]="data.content"
  ></app-dynamic-table>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
